/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Pagination information to be added to response
 */
export interface PaginationInfo {
  total: number;
  page: number;
  pageSize: number;
}
